import { Modal, Button } from "react-bootstrap";

const DeleteConfirmationModal = ({ show, onClose, onDelete, file }) => {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header className="bg-primary text-white" closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete the file <strong>{file?.path}</strong>?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            onDelete(file);
            onClose();
          }}
        >
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;
